import React from "react";
import repeIcon from "../images/repeIcon.png";
export default function NumberPill({ number, estado, onClick }) {
  return (
    <span className={`numberPill ${estado}`} onClick={onClick}>
      {estado === "repe" && <img src={repeIcon} width="20" />}
      {number}
    </span>
  );
}
